import { render } from "./DataDeletionHeader.vue?vue&type=template&id=d3b69b90&scoped=true"
import script from "./DataDeletionHeader.vue?vue&type=script&lang=js"
export * from "./DataDeletionHeader.vue?vue&type=script&lang=js"

import "./DataDeletionHeader.vue?vue&type=style&index=0&id=d3b69b90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b69b90"]])

export default __exports__